var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentFile,_vm._g(_vm._b({tag:"component"},'component',Object.assign({}, _vm.customProps),false),Object.assign({}, _vm.events)))}
var staticRenderFns = []

export { render, staticRenderFns }